const { useState, useCallback, useMemo } = require('react');

const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');

const stepActions = require('../../../spa/actions/step');
const {
  COMMONS: { DEVICE_TYPE },
} = require('../../../../constants');
const { ShippingZipcodeForm } = require('./ShippingZipcodeForm');
const { ShippingDataContext } = require('./useShippingData');

const ShippingZipcodeFormWapper = (props) => {
  const { data, configs } = props;
  const { platform, currency, deviceType } = configs;

  const shippingOptions = data?.shipping_option;
  const hasShippingOptions = shippingOptions?.length;
  const isMobile = deviceType === DEVICE_TYPE.MOBILE;
  const isDesktop = deviceType === DEVICE_TYPE.DESKTOP;

  const [shippingData, setShippingData] = useState({
    shippingOptions,
    hasShippingOptions,
    selectedShippingOption: hasShippingOptions
      ? shippingOptions[0].id
      : undefined,
    zipcode: data?.zip_code,
    locationPayload: data,
    hasZipcodeFinder: data?.has_zip_code_finder,
    siteId: platform?.siteId,
    currency,
    isMobile,
    isDesktop,
    deviceType,
    countryId: platform?.countryId,
  });

  const setShippinData = useCallback((data = {}) => {
    setShippingData((oldData) => ({ ...oldData, ...data }));
  }, []);

  const value = useMemo(
    () => ({
      data: shippingData,
      setShippinData,
    }),
    [shippingData],
  );

  return (
    <ShippingDataContext.Provider value={value}>
      <ShippingZipcodeForm {...props} />
    </ShippingDataContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  flow: state.page.flow,
  configs: state.configurations,
});

const mapDispatchToProps = (dispatch) => ({
  stepAction: bindActionCreators(stepActions, dispatch),
});

module.exports = {
  ShippingZipcodeForm: connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ShippingZipcodeFormWapper),
};
